/*
 * AUTO-GENERATED, DO NOT EDIT
 */
import React from 'react';
function RobotIcon(props, svgRef) {
    return (React.createElement("svg", Object.assign({ "data-sanity-icon": "robot", width: "1em", height: "1em", viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: svgRef }, props),
        React.createElement("rect", { x: 6.5, y: 8.5, width: 12, height: 7, rx: 2, stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("circle", { cx: 10.5, cy: 12, r: 1, stroke: "currentColor" }),
        React.createElement("circle", { cx: 14.5, cy: 12, r: 1, stroke: "currentColor" }),
        React.createElement("circle", { cx: 12.5, cy: 5, r: 1.5, stroke: "currentColor" }),
        React.createElement("path", { d: "M12.5 8.5V6.5", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M4.5 19.5C4.5 18.3954 5.39543 17.5 6.5 17.5H18.5C19.6046 17.5 20.5 18.3954 20.5 19.5V20.5H4.5V19.5Z", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M12.5 15.5V17.5", stroke: "currentColor", strokeWidth: 1.2 })));
}
const ForwardRef = React.forwardRef(RobotIcon);
export default ForwardRef;
//# sourceMappingURL=robotIcon.js.map